import React from 'react';
import { Route } from 'react-router-dom';

class RouteWithProps extends React.Component {
  propsWrapper = {};

  component = null;

  componentRef = React.createRef();

  generateRenderFunction() {
    // Functional components cannot be given `refs` in render methods for react-router-dom
    if (!this.component.prototype || !this.component.prototype.render) {
      // eslint-disable-next-line react/jsx-props-no-spreading, react/no-unstable-nested-components
      return (props) => <this.component {...this.propsWrapper} {...props} />;
    }
    // eslint-disable-next-line react/jsx-props-no-spreading, react/no-unstable-nested-components
    return (props) => <this.component ref={this.componentRef} {...this.propsWrapper} {...props} />;
  }

  render() {
    this.component = this.props.component;
    this.propsWrapper = {
      ...this.props,
      component: undefined,
    };
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Route {...this.propsWrapper} render={this.generateRenderFunction(this.props.noRef)} />;
  }
}

export default RouteWithProps;
